/* eslint-disable class-methods-use-this */
import {type GameDataFirstGameState} from '@colonist/game-state-types'
import {UIMSceneEnum} from '../../../shared/enums/UIMSceneEnums.ts'
import {GameStateEnums, type NetworkEnums} from '../../../shared/GameEnums.ts'
import {type MatchmakingStatusUpdate} from '../../../shared/matchmaking/MatchmakingInterfaces.ts'
import {type SocketDataTypes} from '../../../shared/SocketDataTypes.ts'
import {SocketLobbySend} from '../../shared/scripts/socket/SocketLobbySend.ts'
import {SocketActionController} from '../../shared/scripts/socket/SocketActionController.ts'
import {type UIGameManager} from '../../shared/scripts/ui_game/UIGameManager.ts'
import {UIUrlController} from '../../shared/scripts/ui_html/UIUrlController.ts'
import {type UIMManager} from './ui_html/UIMManager.ts'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {type BaseError} from '../../../shared/errors/BaseError.ts'
import {logError} from '../../shared/scripts/ui_utils/Utils.ts'
import {type UIMGeneralServicesController} from './UIMGeneralServicesController.ts'

export class UIMSocketEventHandler extends SocketActionController {
    readonly uiGameManager: UIGameManager
    private readonly uiManager: UIMManager

    constructor(uiGameManager: UIGameManager, uiManager: UIMManager, generalServicesController: UIMGeneralServicesController) {
        super(generalServicesController)
        this.uiGameManager = uiGameManager
        this.uiManager = uiManager
    }

    onStateSessionState() {
        const isAccessGameFromLinkHandledByRoom = this.uiManager.createRoomController.isUserOnCreateRoomFlow()
        if(!isAccessGameFromLinkHandledByRoom) {
            UIUrlController.accessGameFromLink(async(roomId) => {
                await SocketLobbySend.accessGameFromLink(roomId)
            })
        }
    }

    onConnectionEstablished(data: GameDataFirstGameState) {
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game)
        window.location.hash = data.gameSettingId
    }
    onStateInitialPlacement() {
        this.uiManager.sceneController.loadScene(UIMSceneEnum.Game)
    }
    onMatchmakingUpdate(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        const matchmakingSelectionController = this.uiManager.mainpageController.bodyController.homepageController.matchmakingController
        matchmakingSelectionController.updateMatchmakingStatus(matchmakingStatusUpdate)
    }
    onMatchmakingError(error: BaseError) {
        this.uiManager.mainpageController.bodyController.homepageController.showMatchmakingError(error)
    }

    onMatchmakingDisableAdblock() {
        logError('onMatchmakingDisableAdblock', ['No ad blocker on mobile'])
    }
    onChannelRoomUpdate(roomData: SocketDataTypes.ChannelRoomUpdate) {
        logError('onChannelRoomUpdate', ['No channel room update on mobile'])
    }

    onRoomListUpdate(data: NetworkEnums.RoomListUpdateData) {
        this.uiManager.mainpageController.bodyController.lobbyController.updateRoomList(data)
    }
}
